import React, { useEffect, useState } from 'react';

import { LoadingPanel } from '../components/common/LoadingPanel';
import { ConnectMessages } from '../components/connect-subscription/ConnectMessages.view';

let timeoutId = 0;

export const PollToConnectContainer: React.FC = () => {
  const [shouldDisplayPollMessage, setShouldDisplayPollMessage] = useState(false);
  useEffect(() => {
    clearTimeout(timeoutId);

    timeoutId = window.setTimeout(() => {
      setShouldDisplayPollMessage(true);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  if (!shouldDisplayPollMessage) {
    return <LoadingPanel loadingMessage="Checking connection status..." />;
  }

  return <ConnectMessages connectStatus="poll_until_connect" />;
};
